import React from 'react';
import { useLocalizedName } from '../../lib/utils/formatters';
import { usePageNavigation } from '../../lib/contexts/PageNavigationContext';

const CategorySubNav = () => {
  const { currentPageType, categories, activeCategorySlug, scrollToCategory } = usePageNavigation();

  const getLocalizedName = useLocalizedName();

  // Build slugs for category anchors
  const categoriesWithSlugs = categories.map(category => ({
    ...category,
    slug: category.name.toLowerCase().replace(/\s+/g, '-'),
  }));

  // Only render if we have categories and are on menu or wine-list page
  if (
    !currentPageType ||
    (currentPageType !== 'menu' && currentPageType !== 'wine-list') ||
    categoriesWithSlugs.length === 0
  ) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white shadow-sm pb-4 hidden lg:block">
      <div className="category-sub-nav-inner">
        <div className="flex justify-center gap-3 overflow-x-auto hide-scrollbar py-2 lg:py-3">
          {categoriesWithSlugs.map(category => (
            <button
              key={category.id}
              onClick={() => scrollToCategory(category.slug)}
              className={`font-medium text-sm whitespace-nowrap transition-colors duration-200 px-2 py-1 min-h-[36px] ${
                activeCategorySlug === category.slug
                  ? 'text-red-800 border-b-2 border-red-800'
                  : 'text-neutral-700 hover:text-red-800'
              }`}
            >
              {getLocalizedName(category)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategorySubNav;
